import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import SecurityService from '../../services/SecurityService';
import { isNullOrEmpty, translate } from '../../utils/util';
import SelectNew from './SelectNew';
import { ENUMS } from '../../utils/constants';

const SelectDockUI = (props) => {
    const [docks, setDocks] = useState([]);

    useEffect(() => {
        if (props.sheds && (!isNullOrEmpty(props.shedId) || !isNullOrEmpty(props.user.shed))) {
            filterDock(props.unload ? props.shedsUnload : props.sheds)
        }
        else {
            mapDocks(props.unload ? props.shedsUnload : props.sheds)
        }
        // eslint-disable-next-line
    }, [props.shedId, props.filterArea, props.sheds, props.shedsUnload, props.value]);

    const filterDock = (data) => {
        let docks = [];
        data.filter((i) => i.id === (props.shedId || props.user.shed)).map((i) => {
            const values = i.units.filter((u) => u.unitTypeId === ENUMS.eUnitType.Dock.value);
            if (values) {
                values.map((u) => docks = [...docks, u]);
            }
            return values;
        });

        setDocks([...docks.sort((a, b) => (a.description > b.description) ? 1
            : ((b.description > a.description) ? -1 : 0))]);
    }

    const mapDocks = (data) => {
        let docks = [];
        data.map((i) => {
            const values = i.units.filter((u) => u.unitTypeId === ENUMS.eUnitType.Dock.value);
            if (values) {
                values.map((u) => docks = [...docks, u]);
            }
            return values;
        });

        setDocks([...docks.sort((a, b) => (a.description > b.description) ? 1
            : ((b.description > a.description) ? -1 : 0))]);
    }

    const onChage = (evt) => {
        props.onChange(evt);
        props.setDock(evt.target.value);
    }

    return (
        <SelectNew
            required={props.required}
            id={props.id || 'dock'}
            name={props.id || 'dock'}
            label={translate('dock', 'physical-confirmation')}
            placeHolder={translate('choose-one-option', 'general')}
            data={docks}
            value={props.value}
            valuefield="code"
            display="description"
            change={onChage}
        />
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
        dock: state.configReducer.dock,
        shedsUnload: state.configReducer.shedsUnload
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setDock: (dock) => {
            dispatch(SecurityService.setDock(dock));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectDockUI));
